  (function () {
    if (window.__ix1HeaderInit) return;
    window.__ix1HeaderInit = true;

    var desktop = window.matchMedia('(min-width: 1025px) and (hover: hover)');

    function allDropdowns() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-ix1-dropdown]'));
    }

    function closeAll(except) {
      allDropdowns().forEach(function (d) {
        if (d !== except) d.removeAttribute('open');
      });
    }

    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.hasAttribute || !d.hasAttribute('data-ix1-dropdown')) return;
      if (d.open) closeAll(d);
    }, true);

    // hover to open on desktop
    document.addEventListener('mouseover', function (e) {
      if (!desktop.matches) return;
      var d = e.target.closest ? e.target.closest('[data-ix1-dropdown]') : null;
      if (d && !d.open) {
        closeAll(d);
        d.setAttribute('open', '');
      }
    });

    document.addEventListener('mouseout', function (e) {
      if (!desktop.matches) return;
      var d = e.target.closest ? e.target.closest('[data-ix1-dropdown]') : null;
      if (!d) return;
      if (e.relatedTarget && d.contains(e.relatedTarget)) return;
      d.removeAttribute('open');
    });

    // click outside closes
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ix1-dropdown]')) return;
      closeAll(null);
    });

    // ---- drawer ----
    var drawer = document.querySelector('[data-ix1-drawer]');
    var opener = document.querySelector('[data-ix1-drawer-open]');
    var lastFocus = null;

    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.hidden = false;
      // force a frame so the transition runs
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var close = drawer.querySelector('.ix1-drawer__close');
      if (close) close.focus();
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (opener) opener.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () {
        drawer.hidden = true;
      }, 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ix1-drawer-open]')) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest && e.target.closest('[data-ix1-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer && !drawer.hidden) {
        closeDrawer();
      } else {
        closeAll(null);
      }
    });

    // close drawer if the viewport goes desktop
    window.addEventListener('resize', function () {
      if (desktop.matches && drawer && !drawer.hidden) closeDrawer();
    });
  })();